import { UHHosts, UHBasePaths, UHHeaders, UHSupportBasePath, Environments } from "./env-endpoints";

interface EnvConfig {
  APIPATH: string;
  HEADERS?: {};
  fallbackMock: boolean;
  globalMockEnabled: boolean;
  SUPPORTPATH: string;
}


const local: EnvConfig = {
  fallbackMock: true,
  globalMockEnabled: true,
  APIPATH: UHHosts.get(Environments.LOCAL) + UHBasePaths.get(Environments.LOCAL),
  SUPPORTPATH: `${UHHosts.get(Environments.LOCAL)}${UHSupportBasePath.get(Environments.LOCAL)}`,

  HEADERS: {
    "X-IBM-Client-Id": UHHeaders.LOCAL.CLIENTID,
    "X-IBM-Client-Secret": UHHeaders.LOCAL.CLIENTSECRET,
  },
};

const dev: EnvConfig = {
  fallbackMock: false,
  globalMockEnabled: false,
  APIPATH: UHHosts.get(Environments.DEV) + UHBasePaths.get(Environments.DEV),
  SUPPORTPATH: `${UHHosts.get(Environments.DEV)}${UHSupportBasePath.get(Environments.DEV)}`,

  HEADERS: {
    "X-IBM-Client-Id": UHHeaders.DEV.CLIENTID,
    "X-IBM-Client-Secret": UHHeaders.DEV.CLIENTSECRET,
  },
};

const inte: EnvConfig = {
  fallbackMock: false,
  globalMockEnabled: false,
  APIPATH: UHHosts.get(Environments.INTE) + UHBasePaths.get(Environments.INTE),
  SUPPORTPATH: `${UHHosts.get(Environments.DEV)}${UHSupportBasePath.get(Environments.INTE)}`,
  HEADERS: {
    "X-IBM-Client-Id": UHHeaders.INTE.CLIENTID,
    "X-IBM-Client-Secret": UHHeaders.INTE.CLIENTSECRET,
  },
};
const qa: EnvConfig = {
  fallbackMock: false,
  globalMockEnabled: false,
  APIPATH: UHHosts.get(Environments.QA) + UHBasePaths.get(Environments.QA),
  SUPPORTPATH: `${UHHosts.get(Environments.DEV)}${UHSupportBasePath.get(Environments.QA)}`,
  HEADERS: {
    "X-IBM-Client-Id": UHHeaders.QA.CLIENTID,
    "X-IBM-Client-Secret": UHHeaders.QA.CLIENTSECRET,
  },
};
const prod: EnvConfig = {
  fallbackMock: false,
  globalMockEnabled: false,
  APIPATH: UHHosts.get(Environments.PROD) + UHBasePaths.get(Environments.PROD),
  SUPPORTPATH: `${UHHosts.get(Environments.PROD)}${UHSupportBasePath.get(Environments.PROD)}`,
  HEADERS: {
    "X-IBM-Client-Id": UHHeaders.PROD.CLIENTID,
    "X-IBM-Client-Secret": UHHeaders.PROD.CLIENTSECRET,
  },
};
const EnvConfigs: Map<string, EnvConfig> = new Map<string, any>([
  [Environments.LOCAL, local],
  [Environments.DEV, dev],
  [Environments.INTE, inte],
  [Environments.QA, qa],
  [Environments.PROD, prod],
]);

//TODO workaround ""temporaneo"", sia inte che qa ritornano "col" come environment
const getEnvironment = () => {
  const env = php_pars.environment;
  if (env == "col") {
    return isQA() ? Environments.QA : Environments.INTE;
  } else {
    return env;
  }
}

const isQA = (): boolean => {
  return window.location.host.includes("cliente-uh-qa");
}
export const envConfig: EnvConfig = EnvConfigs.get(getEnvironment());

